import CreatePushNotification from "../symbols/createPushNotification";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function CreateCreatePushNotificationReducer(state = initialState, action: any) {
  switch (action.type) {
    case CreatePushNotification.CREATE_PUSH_NOTIFICATION:
      return { ...state, loading: true, error: false };
    case CreatePushNotification.CREATE_PUSH_NOTIFICATION_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case CreatePushNotification.CREATE_PUSH_NOTIFICATION_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case CreatePushNotification.CLEAR_CREATE_PUSH_NOTIFICATION:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
